module.exports = __webpack_public_path__ + "static/media/3.53b25b53.jpg";